<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'bikeshop.users.leave_date' | translate}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row margin-top-8">
    <div class="col-md-12">
      {{ 'bikeshop.users.technician' | translate}}
      <p-dropdown [options]="users" [(ngModel)]="user"
        placeholder="{{ 'bikeshop.users.select_a_technician' | translate}}" optionLabel="Name"></p-dropdown>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-12">
      {{ 'bikeshop.users.start_date' | translate}}
      <p-calendar [(ngModel)]="startDate" dateFormat="dd/mm/yy" (onSelect)="endDate = startDate"></p-calendar>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-12">
      {{ 'bikeshop.users.end_date' | translate}}
      <p-calendar [(ngModel)]="endDate" dateFormat="dd/mm/yy"></p-calendar>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <button [disabled]="busy" pButton class="full-width" label="{{ 'bikeshop.general.save' | translate}}"
        (click)="save()"></button>
    </div>
  </div>
</div>